var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:({backgroundColor: _vm.bg}),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[(_vm.icon)?_c('div',{style:([{maskImage: `url(./svg/btn/${_vm.icon}.svg)`}, _vm.iconSize?{width: `${_vm.iconSize}px`, height: `${_vm.iconSize}px`}:{}])}):_vm._e(),_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }